import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  DraftReturn: {
    fields: {
      items: {
        merge(_, incoming) {
          return incoming;
        },
      },
    },
  },
};
